var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", {
        staticClass: "margin-medium-top",
        attrs: { label: "LIMITES: ", showBorder: false }
      }),
      _c(
        "el-table",
        { attrs: { stripe: "stripe", data: _vm.limitesAux } },
        [
          _c("el-table-column", {
            attrs: { label: "Direção" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("validation-provider", {
                      ref: "validationLimites" + scope.$index,
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      name: "direcao_" + scope.$index,
                                      clearable: "clearable"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$emit(
                                          "changeLimites",
                                          _vm.limitesAux
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.limitesAux[scope.$index].direcao,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.limitesAux[scope.$index],
                                          "direcao",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "limitesAux[scope.$index].direcao"
                                    }
                                  },
                                  _vm._l(_vm.coordenadas, function(c) {
                                    return _c("el-option", {
                                      key: c.value,
                                      attrs: {
                                        label: c.descricao,
                                        value: c.value
                                      }
                                    })
                                  }),
                                  1
                                ),
                                errors.length
                                  ? _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { formatter: _vm.formattedMarcos, label: "Marcos" }
          }),
          _c("el-table-column", {
            attrs: { prop: "confinante", label: "Confinantes" }
          }),
          _c("el-table-column", {
            attrs: { label: "Distância (m)", prop: "distancia" }
          }),
          _c("el-table-column", {
            attrs: { label: "Azimutes", prop: "azimute" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71f31f44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f31f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppLimites.vue
// module id = null
// module chunks = 